import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  var SEARCH_RESULTS_PATH = '/search';
  var SEARCHANISE_CONTAINERS =
    '.snize-ac-results, .snize-ac-results-mobile, ' +
    '#snize_results, .snize-search-results';

  function patchSearchanisePaths() {
    var sa = window.Searchanise;
    if (!sa) return false;
    if (sa.options) {
      sa.options.ResultsFormPath = SEARCH_RESULTS_PATH;
      sa.options.ResultsDiv = '#snize_results';
    }
    if (sa.userOptions) {
      sa.userOptions.ResultsFormPath = SEARCH_RESULTS_PATH;
      sa.userOptions.ResultsDiv = '#snize_results';
    }
    return true;
  }

  if (!patchSearchanisePaths()) {
    var pathTries = 0;
    var pathIv = setInterval(function () {
      pathTries++;
      if (patchSearchanisePaths() || pathTries > 50) clearInterval(pathIv);
    }, 100);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var viewAll = target.closest(
        '.snize-view-all-link, .snize-view-all-row, a[class*="view-all"], .snize-ac-view-all'
      );
      if (!viewAll) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var input = document.querySelector(
        '#cmdk-input, input.snize-search-box[name="q"], input[name="q"].snize-search-box'
      );
      var q = (input && input.value ? input.value : '').trim();
      var url = SEARCH_RESULTS_PATH + (q ? '?q=' + encodeURIComponent(q) : '');
      window.location.href = url;
    },
    true
  );

  var CART_ADD_URL = /\/cart\/add(\.js)?(\?|#|$)/;
  var CLICK_WINDOW_MS = 2000;
  var lastSearchaniseClick = 0;

  function markSearchaniseClick() {
    lastSearchaniseClick = Date.now();
  }

  function clickIsFromSearchanise() {
    return Date.now() - lastSearchaniseClick < CLICK_WINDOW_MS;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(SEARCHANISE_CONTAINERS)) {
        markSearchaniseClick();
      }
    },
    true
  );

  function getSectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component'))
      .map(function (component) {
        return component.dataset.sectionId;
      })
      .filter(Boolean);
  }

  function getAddedLines(addResponse) {
    var items = Array.isArray(addResponse)
      ? addResponse
      : addResponse && Array.isArray(addResponse.items)
        ? addResponse.items
        : [addResponse];

    return items
      .map(function (item) {
        if (!item) return null;
        var merchandiseId = item.variant_id || item.id;
        if (!merchandiseId) return null;
        return {
          merchandiseId: String(merchandiseId),
          quantity: Number(item.quantity) || 1,
        };
      })
      .filter(Boolean);
  }

  function injectSections(body) {
    var sectionIds = getSectionIds();
    if (!sectionIds.length) return body;

    var sections = sectionIds.join(',');
    var sectionsUrl = window.location.pathname;

    if (typeof body === 'string' && body.trim().charAt(0) === '{') {
      try {
        var parsed = JSON.parse(body);
        parsed.sections = sections;
        parsed.sections_url = sectionsUrl;
        return JSON.stringify(parsed);
      } catch (error) {
        return body;
      }
    }

    if (body instanceof FormData) {
      body.set('sections', sections);
      body.set('sections_url', sectionsUrl);
      return body;
    }

    if (body instanceof URLSearchParams) {
      body.set('sections', sections);
      body.set('sections_url', sectionsUrl);
      return body;
    }

    return body;
  }

  function refreshAndDispatch(addResponse) {
    var lines = getAddedLines(addResponse);
    if (!lines.length) return;

    var deferredPromise = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'dialog',
        lines: lines,
        promise: deferredPromise.promise,
        detail: {
          source: 'searchanise',
          sourceId: 'searchanise',
        },
      })
    );

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') {
          throw new Error('invalid cart response');
        }

        deferredPromise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            didError: false,
            items: cart.items,
            itemCount: cart.item_count,
            sections: addResponse && addResponse.sections ? addResponse.sections : {},
            source: 'searchanise',
            sourceId: 'searchanise',
          },
        });
      })
      .catch(function (error) {
        deferredPromise.reject(error);
      });
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var fromSearchanise = CART_ADD_URL.test(url) && clickIsFromSearchanise();

      if (fromSearchanise && init && init.body) {
        init = Object.assign({}, init, {
          body: injectSections(init.body),
        });
      }

      var promise = origFetch.call(this, input, init);

      if (fromSearchanise) {
        promise
          .then(function (resp) {
            if (!resp || !resp.ok) return;
            return resp.clone().json().then(refreshAndDispatch);
          })
          .catch(function () {});
      }

      return promise;
    };
  }

  var xhrProto = XMLHttpRequest.prototype;
  var origOpen = xhrProto.open;
  xhrProto.open = function (method, url) {
    this.__searchaniseUrl = url || '';
    return origOpen.apply(this, arguments);
  };

  var origSend = xhrProto.send;
  xhrProto.send = function (body) {
    var xhr = this;
    var url = xhr.__searchaniseUrl || '';
    var fromSearchanise = CART_ADD_URL.test(url) && clickIsFromSearchanise();

    if (fromSearchanise) {
      body = injectSections(body);
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        try {
          refreshAndDispatch(JSON.parse(xhr.responseText));
        } catch (error) {}
      });
    }

    return origSend.call(this, body);
  };
})();
